const IS_LOADING = "lists/ratings-certifications/IS_LOADING";
const IS_PARTIAL_LOADING = "lists/ratings-certifications/IS_PARTIAL_LOADING";
const IS_ERROR = "lists/ratings-certifications/IS_ERROR";
const CERTIFICATIONS = "lists/ratings-certifications/CERTIFICATIONS";
const CERTIFICATE = "lists/ratings-certifications/CERTIFICATE";
export { IS_LOADING, IS_PARTIAL_LOADING, IS_ERROR, CERTIFICATIONS, CERTIFICATE };
